var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ageRangeRate && _vm.ageRangeRate.values && _vm.ageRangeRate.labels )?_c('div',{staticClass:"h-100"},[_c('PieChart',{attrs:{"data":_vm.ageRangeRate.values,"labels":_vm.ageRangeRate.labels}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }